// Applied to the nodes that render highlightKeyword()'s <mark> output, which
// is injected as HTML and so can't carry classes of its own.
export const MARK_STYLES =
  "[&_mark]:bg-orange-200 [&_mark]:text-gray-900 [&_mark]:rounded [&_mark]:px-0.5 dark:[&_mark]:bg-orange-400/40 dark:[&_mark]:text-orange-50";

// Dates live on the day-group headers, so rows only ever render a time.
export function formatTime(ts) {
  try {
    const d = new Date(ts);
    return isNaN(d)
      ? ""
      : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

export function formatSummaryTime(ts, language) {
  const d = new Date(ts);
  if (isNaN(d)) return "";
  return d.toLocaleString(language === "zh" ? "zh-TW" : "en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function truncateText(text, maxLength = 140) {
  if (!text || text.length <= maxLength) return text;
  const truncated = text.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(" ");
  return lastSpace > maxLength * 0.7
    ? truncated.substring(0, lastSpace) + "…"
    : truncated + "…";
}

export function highlightKeyword(text, keyword) {
  if (!keyword || !text) return text;
  const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return text.replace(new RegExp(`(${escaped})`, "gi"), "<mark>$1</mark>");
}

function dayLabel(d, language) {
  if (isNaN(d)) return language === "zh" ? "未知日期" : "Unknown date";
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  if (d.toDateString() === today.toDateString())
    return language === "zh" ? "今天" : "Today";
  if (d.toDateString() === yesterday.toDateString())
    return language === "zh" ? "昨天" : "Yesterday";
  return d.toLocaleDateString(language === "zh" ? "zh-TW" : "en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

// Rows arrive newest-first, so a sequential pass is enough to bucket them
// into day sections.
export function groupByDay(items, language) {
  const groups = [];
  for (const item of items) {
    const d = new Date(item.created_at);
    const key = isNaN(d) ? "unknown" : d.toDateString();
    const last = groups[groups.length - 1];
    if (!last || last.key !== key) {
      groups.push({ key, label: dayLabel(d, language), items: [item] });
    } else {
      last.items.push(item);
    }
  }
  return groups;
}
